import {
  Negotiation as WsNegotiation,
  NegotiationType,
} from '@/redux/types/negotiationWebsocket'
import { Negotiation as RoomNegotiation } from '@/redux/types/room'

/** Maps REST room negotiation shape to WebSocket Redux negotiation shape. */
export const mapRoomNegotiationToWs = (
  negotiation: RoomNegotiation
): WsNegotiation => ({
  negotiationId: String(negotiation.id),
  inviter: negotiation.inviter,
  members: negotiation.members || [],
  starttime: negotiation.starttime || new Date().toISOString(),
  round_number: negotiation.round_number,
  member_count:
    negotiation.member_count || negotiation.members?.length || 0,
  is_one_on_one:
    negotiation.is_one_on_one ||
    (negotiation.members?.length === 2 &&
      negotiation.negotiation_type === NegotiationType.PRIVATE_ROOM),
  negotiation_type:
    negotiation.negotiation_type || NegotiationType.PRIVATE_ROOM,
  end_time: negotiation.end_time,
  phase_id: negotiation.phase_id,
  room_id: negotiation.room_id,
})

export const findRoomNegotiationById = (
  roomNegotiations: RoomNegotiation[],
  negotiationId: string
): RoomNegotiation | undefined =>
  roomNegotiations.find((n) => String(n.id) === negotiationId)
